import type { TrazadoBiblioteca } from '@/lib/marketing/geometriaBiblioteca';

/** Los cinco anillos discontinuos de la biblioteca; los pintan igual el héroe y la sección Biblioteca. */
export default function AnillosGuia({ trazado }: { trazado: TrazadoBiblioteca }) {
    return (
        <g fill="none" strokeWidth={trazado.grosorAnillo} className="stroke-ink/25">
            {trazado.anillos.map(({ r, guiones }) => (
                <circle key={r} cx={trazado.centro.x} cy={trazado.centro.y} r={r} strokeDasharray={guiones} strokeDashoffset={trazado.desfaseGuiones} />
            ))}
        </g>
    );
}
